<template>
  <div>
    <div class="flex menu-bar">
      <div class="flex gap12">
        <div style="flex-shrink: 0;">招聘单位</div>
        <el-input v-model="searchParams.select1768183720059label"  clearable placeholder="请输入招聘单位"></el-input>
      </div>
      <div class="flex gap12">
        <div style="flex-shrink: 0;">岗位名称</div>
        <el-input v-model="searchParams.select1768183787764label" clearable placeholder="请输入岗位名称"></el-input>
      </div>
      <div class="flex">
        <el-button size="mini" icon="el-icon-search" type="warning" @click="search">搜索</el-button>
        <el-button size="mini" icon="el-icon-search" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="table-box">
      <el-table
        :data="tableData"
        border
        :header-cell-style="{background: '#fff6e8',color: '#515a6e'}"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50rem"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :prop="value"
          :label="item" 
          v-for="item,value in tableTitle"
          :key="item"
          align="center"
        >
        </el-table-column>
         <el-table-column
          prop="name"
          label="操作"
          width="180rem"
          align="center"
        >
         <template slot-scope="scope">
             <button class="button" @click="toDetails(scope.row)">查看</button>
          </template>
        </el-table-column>
      </el-table>
       <div class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="16"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {queryForm} from '@/api/api.js';
import {findRoute} from '@/utils/routerHelper.js'
export default {
  data(){
    return{
      searchParams:{
        select1768183787764label:'',//搜索岗位名称
        select1768183720059label:'',//搜索招聘单位
      },
      tableTitle:{
        select1768183720059label:'招聘单位',
        select1768183787764label:'招聘岗位',
        date1768183841683:'发布时间',
        date1768183815814:'截止时间',
      },
      tableData: [
      // {
      //   company:'攀枝花东区社会工作协会服务中心',
      //   position:'一线社工',
      //   startTime:'2025-12-10',
      //   endTime:'2026-01-09',

      // }, {
      //   company:'攀枝花东区社会工作协会服务中心',
      //   position:'一线社工',
      //   startTime:'2025-12-10',
      //   endTime:'2026-01-09',

      // }, {
      //   company:'攀枝花东区社会工作协会服务中心',
      //   position:'一线社工',
      //   startTime:'2025-12-10',
      //   endTime:'2026-01-09',

      // },{
      //   company:'攀枝花东区社会工作协会服务中心',
      //   position:'一线社工',
      //   startTime:'2025-12-10',
      //   endTime:'2026-01-09',

      // },
      ],
      currentPage:0,
      total:0,
    }
  },
  created(){
    this.getData()
  },
  methods:{
    toDetails(row){
      this.$router.push({
        path: '/recruitmentDetails',
        query: {
          id: row.id
        }
      })
      let routerList=[]
      let routers = ['/memberService','memberServiceRecruitment', '/recruitmentDetails'];
      for (let i = 0; i < routers.length; i++) {
        let routerData=findRoute(this.$router.options.routes, routers[i])
        routerList.push(routerData)
      }
      this.$store.commit('routerData/changeRouterList',routerList)
      
    },
    getData(){
      queryForm(
        {
          formKey: "cj3MrDyo",
          queryId: "281",
          queryParams: {
            workflowStatus: "通过",
            ...this.searchParams
          },
          size: 10,
          current:this.currentPage,
        }
      ).then(res=>{
        if(res.data.code==200){
          this.tableData=res.data.data.rows.map(v=>{
            v.date1768183841683=v.date1768183841683.slice(0, -3)
            v.date1768183815814=v.date1768183815814.slice(0, -3)
            return v
          })
          // console.log(res)
        }
      })
    },
    search(){
      this.currentPage=0
      this.getData()
    },
    reset(){
      this.searchParams={
        select1768183787764label:'',
        select1768183720059label:'',
      }
    },
    handleSizeChange(){

    },
    handleCurrentChange(){
        
    }
  }
}
</script>

<style lang="less" scoped>
.menu-bar{
  font-size: 14px;
  color: #606266;
  gap:21px;
}
.gap12{
  gap:12px;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #ED9D26;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #ED9D26;
  border-color: #ED9D26;
}
.table-header{
  background: #fff6e8;
  border: 1px solid #f5f0eb;
}
.table-box{
  margin-top:20px;
  width:1208px;
  overflow: hidden;
}
.button{
  height: 24px;
  line-height: 24px;
  background: #ed9d26;
  border-radius: 4px;
  padding:0 8px;
  border:none;
  margin-right:8px;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

.pages{
    margin-top:34px;
    display: flex;
    justify-content: flex-end;
}
::v-deep .el-pager li.active{
    color: #ED9D26;
}
</style>